import { createAction, props } from '@ngrx/store';
import { ProposalAction, ProposalStatus } from 'src/app/public/buy/constants/buy-basic-data';
import { ProposalModif } from 'src/app/public/buy/models/proposal-modif.model';
import { Proposal } from 'src/app/public/buy/models/proposal.model';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';

export class BuyActions {

    // fetch my favorite cars
/*
    public static fetchFavoriteCarsSubmit = createAction(
        '[My Favorites Component] Fetch my  Favorites Cars',
        props <{ favorites: string[] }> ()
    );

    public static fetchFavoriteCarBriefsSubmit = createAction(
        '[My Favorites Component] Init My Favorites Component'
    );

    public static fetchFavoriteCarsSuccess = createAction(
        '[Dealer API] fetch My Favorite Cars Success',
        props <{ cars: Car[] }> ()
    );

    public static fetchFavoriteCarBriefsSuccess = createAction(
        '[Dealer API] fetch My Favorite Car Briefs Success',
        props <{ carBriefs: CarBrief[] }> ()
    );
*/

    // Proposals 

    public static proposalNewSubmit = createAction(
        '[Car Component] proposal New Submit',
        props <{ proposal: Proposal, objectSource: ObjectSource }> ()
    );

    // public static proposalNewSuccess = createAction(
    //     '[Car Component] proposal New Success',
    //     props <{ proposal: Proposal }> ()
    // );
    
    /*
    public static proposalUpdateSubmit = createAction(
        '[Car Component] proposal Update Submit',
        props <{ proposal: Proposal, objectSource: ObjectSource }> ()
    );
    */
    public static proposalActionSubmit = createAction(
        '[Car Component] proposal Action Submit',
        props <{ proposalAction: ProposalAction, proposal: Proposal | ProposalModif, objectSource: ObjectSource }> ()
    );

    public static proposalUpsertSuccess = createAction(
        '[Car Component] proposal Update Success',
        props <{ proposal: Proposal, objectSource: ObjectSource }> ()
    );

    public static proposalStatusUpdateSubmit = createAction(
        '[Car API] Update proposal status submit',
        props <{ proposalId: number, status: ProposalStatus, objectSource: ObjectSource }> ()
    );

    // public static proposalStatusUpdateSuccess = createAction(
    //    '[Car API] Update proposal status success',
    //     props <{ proposal: Proposal }> ()
    // );

    public static proposalRescheduleSubmit = createAction(
        '[Car Component] proposal Reschedule Submit',
        props <{ proposalId: number, rescDate: string, objectSource: ObjectSource }> ()
    );

    // public static proposalRescheduleSuccess = createAction(
    //     '[Car Component] proposal Reschedule Success',
    //     props <{ proposal: Proposal }> ()
    // );

}